import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="432.689"
      height="1082.015"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 432.689 1082.015"
      xmlSpace="preserve"
      className='clickable'
    >
      <g transform="translate(-149.562 -1030.022)" fill='rgba(0,0,0,0)' className='object-glow'>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
          d="M226.8 1052.8c13.097 1.01 27.012-1.63 39.291 3.03 10.453 3.98 20.304 11.81 25.634 21.64 8.601 15.87 11.735 34.35 14.394 52.2 3.181 21.36 5.571 43.26 3.018 64.71-1.874 15.74-5.442 32.99-16.052 44.77-17.918 19.9-47.728 26.33-65.782 46.1-19.734 21.61-40.536 46.43-45.097 75.34-6.353 40.26 16.1 80.77 14.042 121.49-.458 9.06-1.993 19.19-4.176 29.97-.391 1.93-4.73 4.65-4.73 4.65s-13.972 10.63-16.113 18.92C161.219 1574.34 162 1622.68 162 1652c0 9 9.191 12.13 9.191 12.13s12.039 63.98 10.146 96.09c-2.535 42.98-34.677 83.38-28.48 125.98 6.882 47.32 40.669 93.82 59.462 133.78 11.686 24.85 15.967 52.68 28.681 77.02 2.267 4.34 10.494 5.67 15.206 7 26.252 7.43 65.051 6.01 89.702 3.45C441.529 2097.5 578 1982 579.751 1969.22c-2.751-14.22-32.926-76.87-52.782-113.61-27.275-50.46-72.321-92.57-88.423-147.62-8.557-29.26 7.896-90.84 7.896-90.84L462 1620s8.952-26.84 9-30c.123-8.01-13-18-22.281-23.63-2.317-35.83-9.29-71.7-5.246-107.27 1.952-17.18 2.783-35.08 9.606-50.96 4.701-10.94 17.054-16.84 23.752-26.69 12.904-18.97 17.723-44.03 16.118-66.92-1.127-16.07-2.216-32.65-8.068-47.66-20.487-52.56-46.987-102.58-70.481-153.87 1.901 16.55 43.6 115 3.6 102-36.383-11.82-98-160-136.89-176.78-6.887-2.97-14.655-7.12-21.899-5.17-12.219 3.28-21.607 13.17-32.411 19.75z"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5.899"
          d="M203 1503.6c-4 1.4-5.187 1.97-8 4.4-2.342 2.02-1.372 3.75-4 6-5.5 4.71-14 11-19 20-6 18-7.886 47.9-9 66-1.044 16.96-1.938 36.03-1 53 .2 3.62 1.103 5.83 4 8 12 9 28.591 12.43 42.188 15.44 37.656 8.36 79.598 20.36 119.167 15.26 35.87-4.62 30.045-47.47 52.94-68.48 21.094-19.35 59.534-6.73 81.705-3.42 3-7.8 6.628-17.29 8-24.8.567-3.1 1.529-5.77.094-8.82-2.863-6.09-8.242-10.94-14.094-15.18-12.245-8.88-28.277-14.45-39.708-18.64C373.21 1536.58 261 1502 203 1503.6z"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M296.289 1406.14s21.725-4.32 46.679-4.19c9.585.05 31.646 5.97 50.862 4.09 18.964-1.85 35.634-6.81 43.601-13.28"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M334.669 1198.31s37.34 11.28 66.128 25.61c28.788 14.33 49.024 31.71 49.024 31.71s-25.376-15.44-53.443-27.83c-28.068-12.4-58.827-21.75-58.827-21.75"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M226.991 1750.85s21.558-4.82 46.147-6.89c24.589-2.07 52.209-1.4 52.209-1.4"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M219.463 1758.02s33.597-7.97 58.186-10.04c24.589-2.08 55.84-.86 55.84-.86"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M275.045 1765.62s5.373-1.99 12.17-2.78c6.796-.8 15.016-.42 15.016-.42"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M276.218 1770.13s10.644-.85 20.976-2.42c10.332-1.58 20.351-3.88 20.351-3.88"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M441.624 1741.19s-14.516 37.66-31.913 53.4"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M454.397 1755.5s-10.689 26.52-21.095 45.44c-10.406 18.91-31.372 41.97-31.372 41.97"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M458.301 1778.9s-11.455 43.93-30.707 68.42c-21.059 26.77-88.88 56.95-88.88 56.95"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M478.911 1798.98s-5.157 17.5-15.563 36.41c-10.406 18.92-38.121 40.63-38.121 40.63"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M485.3 1824.14s-3.674 11.34-14.08 30.26c-10.405 18.92-29.777 42.43-29.777 42.43"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M515.439 1873.72s-11.815 48.58-67.542 90.21c-64.104 47.88-110.937 40.47-110.937 40.47"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M530.977 1895.33s-16.922 14.78-30.158 32.71c-12.82 17.38-36.393 37.21-36.393 37.21"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M293.065 1394.24s13.096-.54 25.228.2c12.132.74 23.3 2.76 23.3 2.76s-11.525 1.12-25.241 1.88c-13.716.75-29.623 1.14-29.623 1.14"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M401.99 1549.83l-29.586 79.31"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M192.163 1515.8s16.395-.3 37.964 2.97c16.424 2.49 37.785 5.63 59.95 10.68 21.131 4.81 83.97 21.53 91.733 27.3"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M319.667 1645.69s2.151 10.75 5.736 21.37c3.586 10.61 8.605 21.11 8.605 21.11"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M168.961 1616.42s.343 8.68-.841 17.48c-1.185 8.79-3.897 17.68-3.897 17.68"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M393.543 1548.8a5.01 5.01 0 00-1.599-.67l-7.072-1.67a.66.66 0 00-.691.28l-2.775 4.4a.638.638 0 00.043.75l1.067 1.31c.236.28.64.33.917.09.276-.23.326-.64.091-.91l-.775-.93 2.289-3.63 6.595 1.57a4 4 0 012.462 6.02l-.59.93a3.976 3.976 0 01-1.95 1.59c-.334.12-.499.51-.376.84.045.13.15.25.26.32.165.1.377.13.579.06a5.21 5.21 0 002.587-2.11l.59-.94c1.55-2.46.805-5.75-1.652-7.3zm-13.341-4.66a1.295 1.295 0 00-1.714.73l-2.293 5.71c-.278.69.039 1.43.732 1.71s1.435-.04 1.714-.73l2.293-5.71a1.292 1.292 0 00-.732-1.71zm-6.298 5.45l2.293-5.7a1.3 1.3 0 00-.731-1.72 1.296 1.296 0 00-1.715.73l-2.293 5.71c-.278.69.039 1.44.732 1.71.693.28 1.436-.03 1.714-.73zm-4.737-1.64l2.293-5.71a1.29 1.29 0 00-.731-1.71 1.294 1.294 0 00-1.714.73l-2.293 5.71a1.29 1.29 0 00.731 1.71c.693.28 1.436-.04 1.714-.73zm-3.175-8.97a1.294 1.294 0 00-1.714.73l-2.293 5.71c-.279.69.038 1.44.731 1.71.693.28 1.436-.03 1.714-.73l2.293-5.7c.279-.7-.038-1.44-.731-1.72zm-6.129 5.71l2.001-5.81c.243-.71-.111-1.44-.817-1.68a1.295 1.295 0 00-1.675.82l-2.001 5.81c-.244.71.111 1.43.817 1.68.706.24 1.432-.11 1.675-.82z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M379.935 1567.9c1.155.73 2.567.93 3.863.54a4.785 4.785 0 002.954-2.57l5.409-11.79a2.987 2.987 0 00-1.124-3.78c-.587-.37-1.301-.54-1.984-.43a.631.631 0 00-.559.72c.052.37.359.61.724.56.396-.06.795.04 1.125.25.715.45 1.003 1.38.644 2.15l-5.41 11.78c-.41.9-1.199 1.58-2.142 1.86a3.47 3.47 0 01-2.806-.39 3.44 3.44 0 01-.809-5.1l6.071-7.27c.222-.27.205-.69-.083-.92a.666.666 0 00-.924.08l-6.071 7.27a4.852 4.852 0 00-1.048 3.78 4.812 4.812 0 002.17 3.26z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M389.191 1552.21l-3.117-1.97a.648.648 0 00-.897.21.63.63 0 00.203.89l3.117 1.97c.312.2.7.11.897-.2a.644.644 0 00-.203-.9zm-6.11 10.5c-.607-.38-1.41-.2-1.794.41-.383.6-.201 1.41.407 1.79a1.301 1.301 0 001.387-2.2z"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M389.485 1560.96l5.707 3.06"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M356.123 1535.48c-.716-.22-1.426.17-1.637.89l-1.739 5.9a1.29 1.29 0 00.891 1.63c.716.21 1.426-.17 1.637-.89l1.739-5.9a1.29 1.29 0 00-.891-1.63z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M332.514 1528.83a1.298 1.298 0 00-1.653.86l-1.843 5.87a1.29 1.29 0 00.862 1.65c.712.23 1.428-.15 1.652-.86l1.844-5.87c.224-.71-.15-1.43-.862-1.65z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M308.623 1522.64a1.294 1.294 0 00-1.608.94l-1.554 5.95c-.189.73.219 1.42.942 1.61.722.19 1.419-.22 1.608-.94l1.554-5.95a1.297 1.297 0 00-.942-1.61z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M284.856 1517.11a1.293 1.293 0 00-1.59.97l-1.437 5.98c-.175.73.247 1.42.973 1.59.726.17 1.415-.25 1.59-.97l1.437-5.98c.174-.73-.247-1.42-.973-1.59z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M261.024 1512.9a1.29 1.29 0 00-1.555 1.02l-1.23 6.03c-.15.73.296 1.4 1.027 1.55a1.29 1.29 0 001.555-1.02l1.23-6.03c.15-.73-.295-1.41-1.027-1.55z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M237.109 1508.69a1.295 1.295 0 00-1.498 1.11l-.907 6.08c-.11.74.37 1.39 1.109 1.5.739.11 1.388-.37 1.498-1.11l.907-6.08c.11-.74-.37-1.39-1.109-1.5z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M350.46 1541.86l1.877-5.86a1.298 1.298 0 00-.852-1.66 1.292 1.292 0 00-1.657.85l-1.878 5.86c-.228.71.142 1.43.853 1.66.711.23 1.429-.14 1.657-.85z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M326.803 1535.08l1.83-5.87a1.294 1.294 0 00-.866-1.65 1.3 1.3 0 00-1.65.87l-1.83 5.87c-.222.71.153 1.43.866 1.65.713.22 1.428-.15 1.65-.87z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M303.244 1529.07l1.608-5.94a1.286 1.286 0 00-.928-1.61c-.721-.2-1.421.2-1.616.92l-1.608 5.94a1.3 1.3 0 00.928 1.62 1.3 1.3 0 001.616-.93z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M279.654 1523.87l1.439-5.98c.175-.73-.247-1.42-.973-1.59a1.293 1.293 0 00-1.589.97l-1.44 5.98c-.175.73.247 1.42.973 1.59.726.17 1.415-.25 1.59-.97z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M256.11 1519.45l1.183-6.04c.143-.73-.308-1.4-1.04-1.54-.733-.15-1.403.3-1.547 1.04l-1.182 6.03c-.144.74.307 1.41 1.04 1.55.733.14 1.403-.31 1.546-1.04z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M232.48 1515.59l1.083-6.05c.131-.74-.33-1.4-1.065-1.53a1.296 1.296 0 00-1.53 1.06l-1.082 6.06c-.132.73.33 1.39 1.065 1.53.735.13 1.398-.33 1.529-1.07z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M345.633 1540.22l2.035-5.8c.248-.71-.102-1.44-.807-1.68-.704-.25-1.432.1-1.68.8l-2.035 5.81c-.248.7.102 1.43.807 1.68.705.24 1.432-.11 1.68-.81z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M322.069 1533.88l1.826-5.87a1.296 1.296 0 00-.868-1.65 1.299 1.299 0 00-1.649.87l-1.826 5.87c-.222.71.154 1.43.867 1.65.713.22 1.428-.15 1.65-.87z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M298.537 1528.02l1.554-5.95a1.297 1.297 0 00-.942-1.61c-.723-.18-1.419.22-1.608.95l-1.554 5.95c-.188.72.22 1.42.942 1.6.723.19 1.42-.22 1.608-.94z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M274.864 1523.03l1.535-5.95a1.299 1.299 0 00-.948-1.61 1.303 1.303 0 00-1.605.95l-1.534 5.96c-.186.72.224 1.41.948 1.6.723.19 1.418-.22 1.604-.95z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M251.355 1518.54l1.216-6.02a1.299 1.299 0 00-1.031-1.56c-.732-.14-1.404.3-1.552 1.03l-1.216 6.03c-.148.74.299 1.41 1.031 1.56.732.14 1.404-.3 1.552-1.04z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M227.928 1515.02l.736-6.1a1.294 1.294 0 00-1.151-1.47 1.295 1.295 0 00-1.466 1.15l-.736 6.11a1.29 1.29 0 001.151 1.46c.741.09 1.376-.41 1.466-1.15z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M341.918 1531.12a1.3 1.3 0 00-1.637.89l-1.748 5.9c-.212.72.173 1.42.889 1.64.716.21 1.426-.18 1.638-.89l1.747-5.9c.213-.71-.173-1.42-.889-1.64z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M318.069 1524.89a1.298 1.298 0 00-1.602.96l-1.516 5.96c-.184.72.229 1.41.952 1.6.724.18 1.418-.23 1.602-.95l1.517-5.96a1.303 1.303 0 00-.953-1.61z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M294.447 1519.51a1.298 1.298 0 00-1.615.93l-1.603 5.94c-.195.72.208 1.42.929 1.61.721.2 1.421-.2 1.615-.93l1.603-5.93a1.301 1.301 0 00-.929-1.62z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M270.495 1514.54c-.732-.15-1.406.3-1.554 1.03l-1.227 6.03c-.149.73.297 1.4 1.028 1.55.732.15 1.406-.3 1.555-1.03l1.226-6.02a1.302 1.302 0 00-1.028-1.56z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M246.514 1510.02c-.74-.1-1.382.39-1.48 1.13l-.811 6.1c-.099.74.392 1.38 1.132 1.48a1.29 1.29 0 001.48-1.13l.811-6.1a1.295 1.295 0 00-1.132-1.48z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M222.802 1507.32c-.741-.09-1.379.4-1.473 1.14l-.771 6.11c-.094.74.401 1.37 1.142 1.47.741.09 1.379-.4 1.473-1.14l.771-6.11c.094-.74-.401-1.37-1.142-1.47z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M336.308 1537.29l1.774-5.89c.216-.72-.166-1.43-.881-1.64a1.286 1.286 0 00-1.642.88l-1.774 5.89c-.216.71.166 1.42.881 1.64.715.21 1.427-.17 1.642-.88z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M312.732 1531.33l1.582-5.94a1.29 1.29 0 00-.934-1.61c-.721-.19-1.42.21-1.612.93l-1.583 5.94c-.192.73.212 1.42.934 1.62.722.19 1.42-.22 1.613-.94z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M289.076 1525.85l1.532-5.95a1.299 1.299 0 00-.948-1.61 1.302 1.302 0 00-1.605.95l-1.531 5.96c-.186.72.225 1.41.948 1.6.723.19 1.418-.23 1.604-.95z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M265.443 1521.42l1.44-5.98a1.285 1.285 0 00-.972-1.58 1.286 1.286 0 00-1.59.97l-1.441 5.98a1.3 1.3 0 00.973 1.59 1.3 1.3 0 001.59-.98z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M242.014 1516.99l.971-6.07c.117-.74-.356-1.4-1.094-1.51a1.289 1.289 0 00-1.509 1.09l-.971 6.07c-.118.74.356 1.39 1.094 1.51.737.12 1.391-.35 1.509-1.09z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M218.409 1514.34l.822-6.09c.099-.74-.39-1.38-1.13-1.48-.74-.1-1.382.39-1.482 1.13l-.822 6.09c-.099.74.39 1.38 1.13 1.48.74.1 1.383-.39 1.482-1.13z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M213.672 1513.98l.822-6.09c.1-.74-.39-1.39-1.13-1.49-.74-.1-1.382.39-1.482 1.13l-.821 6.1c-.1.74.389 1.38 1.129 1.48.741.1 1.383-.39 1.482-1.13z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M208.936 1513.99l.821-6.1c.1-.74-.39-1.38-1.13-1.48-.74-.1-1.382.39-1.482 1.13l-.821 6.1c-.1.74.39 1.38 1.13 1.48.74.1 1.382-.39 1.482-1.13z"
          opacity="1"
        ></path>
        <path
          fill="#ff5c97"
          fillRule="nonzero"
          stroke="none"
          d="M204.199 1513.54l.821-6.09c.1-.74-.389-1.39-1.13-1.49-.74-.1-1.382.39-1.482 1.13l-.821 6.1c-.1.74.39 1.38 1.13 1.48.74.1 1.382-.39 1.482-1.13z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;